import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IAlgoStrategyLookupService } from "../IAlgoStrategyLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class AlgoStrategyLookupService
  extends BaseLookupService<string, CubiqTS.AlgoStrategyImpl>
  implements IAlgoStrategyLookupService
{
  constructor() {
    super(CubiqTS.AlgoStrategyImpl);
  }

  getAlgoStrategy(id: string): CubiqTS.AlgoStrategyImpl {
    if (typeof id !== "string") return null;
    const algo = this.getItem(id);
    return algo;
  }

  getAllAlgoStrategyIds(): Array<string> {
    return this.getAll().map((item) => item.id);
  }

  hasAlgoStrategy(id: string): boolean {
    if (typeof id !== "string") return false;

    return this.myItemMap.has(id);
  }

  getItemKey(item: CubiqTS.AlgoStrategyImpl): string {
    if (item !== null && item instanceof CubiqTS.AlgoStrategyImpl && typeof item.id === "string") {
      return item.id;
    }

    return null;
  }
}
